import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllTickets = (query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.tickets.fetchAllTickets(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_TICKETS_FAILED,
              reject: actionTypes.FETCH_ALL_TICKETS_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_TICKETS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_TICKETS_SUCCESS, res);
  return request();
};

export const fetchTicketById = (id) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.tickets.fetchTicketById(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_TICKET_BY_ID_FAILED,
              reject: actionTypes.FETCH_TICKET_BY_ID_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_TICKET_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_TICKET_BY_ID_SUCCESS, res);
  return request();
};

export const replyToTicket = (ticketId, content) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.tickets.replyToTicket(ticketId, content)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.REPLY_TO_TICKET_FAILED,
              reject: actionTypes.REPLY_TO_TICKET_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.REPLY_TO_TICKET_LOADING);
  const success = res => action(actionTypes.REPLY_TO_TICKET_SUCCESS, res);
  return request();
};

export const closeTicket = (ticketId) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.tickets.closeTicket(ticketId)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CLOSE_TICKET_FAILED,
              reject: actionTypes.CLOSE_TICKET_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CLOSE_TICKET_LOADING);
  const success = res => action(actionTypes.CLOSE_TICKET_SUCCESS, res);
  return request();
};

export const fetchAllUserTickets = (ticketId, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.tickets.fetchAllUserTicketsById(ticketId, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.USER_TICKETS_FAILED,
              reject: actionTypes.USER_TICKETS_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.USER_TICKETS_LOADING);
  const success = res => action(actionTypes.USER_TICKETS_SUCCESS, res);
  return request();
};
